import { render, staticRenderFns } from "./PrintVaccineRegistration.vue?vue&type=template&id=f5595ce8&"
import script from "./PrintVaccineRegistration.vue?vue&type=script&lang=js&"
export * from "./PrintVaccineRegistration.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/opt/atlassian/pipelines/agent/build/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('f5595ce8')) {
      api.createRecord('f5595ce8', component.options)
    } else {
      api.reload('f5595ce8', component.options)
    }
    module.hot.accept("./PrintVaccineRegistration.vue?vue&type=template&id=f5595ce8&", function () {
      api.rerender('f5595ce8', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/VaccineViews/VaccineRegistrationPage/components/PrintVaccineRegistration.vue"
export default component.exports